import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { passwordOrAKVtoSecretBase, secretBaseToPasswordOrAKV } from 'app/model/adapters/linkedservices/azure-key-vault.util';
import { SapOpenHubLinkedService } from '../../linkedservice/sap-open-hub.linkedservice';
import { stringIsNullOrEmpty } from 'app/shared/utils/string.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapOpenHubLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                server: '*',
                systemNumber: '*',
                messageServer: '*',
                messageServerService: '*',
                systemId: '*',
                logonGroup: '*',
                clientId: '*',
                language: '*',
                userName: '*',
                password: 'secret',
                encryptedCredential: '*'
            }
        }
    }
})
export class SapOpenHubLinkedServiceAdapter extends LinkedServiceAdapter<SapOpenHubLinkedService> {
    protected modelConstructor(): new () => SapOpenHubLinkedService {
        return SapOpenHubLinkedService;
    }

    protected model(): IModel {
        return SapOpenHubLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: SapOpenHubLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.SapOpenHubLinkedService;

        properties.type = Metamodel.modelFor(SapOpenHubLinkedService).name;

        properties.typeProperties = {
            clientId: linkedService.clientId,
            language: linkedService.language || undefined,
            userName: linkedService.userName,
            password: passwordOrAKVtoSecretBase(linkedService.password, this.context)
        };
        if (linkedService.logonType === 'applicationServer') {
            properties.typeProperties.server = linkedService.server;
            properties.typeProperties.systemNumber = linkedService.systemNumber;
        } else {
            properties.typeProperties.messageServer = linkedService.messageServer;
            properties.typeProperties.messageServerService = linkedService.messageServerService || undefined;
            properties.typeProperties.systemId = linkedService.systemId || undefined;
            properties.typeProperties.logonGroup = linkedService.logonGroup || undefined;
        }

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: SapOpenHubLinkedService): Promise<SapOpenHubLinkedService> {
        const prop = linkedServiceResource.properties as Model.SapOpenHubLinkedService;
        if (prop.typeProperties != null) {
            linkedService.logonType = !stringIsNullOrEmpty(prop.typeProperties.messageServer) ? 'group' : 'applicationServer';
            if (linkedService.logonType === 'applicationServer') {
                linkedService.server = prop.typeProperties.server;
                linkedService.systemNumber = prop.typeProperties.systemNumber;
            } else {
                linkedService.messageServer = prop.typeProperties.messageServer;
                linkedService.messageServerService = prop.typeProperties.messageServerService;
                linkedService.systemId = prop.typeProperties.systemId;
                linkedService.logonGroup = prop.typeProperties.logonGroup;
            }
            linkedService.clientId = prop.typeProperties.clientId;
            linkedService.language = prop.typeProperties.language;
            linkedService.userName = prop.typeProperties.userName;
            linkedService.password = secretBaseToPasswordOrAKV(prop.typeProperties.password, true, this.context);
        }

        return linkedService;
    }
}
